import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getReservedChannels = createAsyncThunk("reservedChannel/getReservedChannel", async (payload) => {
  try {
    const response = await magnifiAPI.getReservedChannels(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const addReservedChannel = createAsyncThunk("reservedChannel/addReservedChannel", async (payload) => {
  try {
    const response = await magnifiAPI.addReservedChannel(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateReservedChannel = createAsyncThunk("reservedChannel/updateReservedChannel", async (payload) => {
  try {
    const response = await magnifiAPI.updateReservedChannel(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteReservedChannel = createAsyncThunk("reservedChannel/deleteReservedChannel", async (payload) => {
  try {
    const response = await magnifiAPI.deleteReservedChannel(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
